import { NgModule, TRANSLATIONS_FORMAT, PLATFORM_ID, inject } from '@angular/core';
import { LOCALE_ID_PROVIDER } from './core/services/i18n/locale-id.provider';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// declare const require; // Use the require method provided by webpack

import { CoreModule } from './core/core.module';
import { APP_BASE_HREF, CommonModule, isPlatformServer } from '@angular/common';
import { RouteReuseStrategy, UrlSerializer } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { AppGlobalsModule } from './app-globals.module';
import { EsiFactoryModule } from './esi-factory/esi-factory.module';
import { CategoryService } from './category/category.service';
import { CustomRouteReuseStrategy } from './route-reuse/CustomRouteReuseStrategy';
import { LowercaseRouteUrlSerializer } from './route-reuse/lowercase-route-url-serializer';
// import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';

@NgModule({
    declarations: [AppComponent],
    imports: [
        // yeshiva moduls:
        CommonModule,
        CoreModule,
        AppRoutingModule,
        // featurs modules:
        EsiFactoryModule,
    ],
    providers: [
        // provideClientHydration(withNoHttpTransferCache()),
        { provide: APP_BASE_HREF, useValue: '/' },
        // { If you even need this code back you would need to `npm install raw-loader@0.5.1`
        //     provide: TRANSLATIONS,
        //     useFactory: (locale) => {
        //         console.log('locale', locale);
        //         locale = locale || 'he-IL'; // default to english if no locale provided
        //         if (locale.contains('en')) {
        //             return require(`raw-loader!../locale/messages.en-US.xlf`);
        //         }
        //         // return require(`raw-loader!../locale/source.xlf`); // Added for clarification, no need since it's the default.
        //     },
        //     deps: [LOCALE_ID],
        // },
        { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
        LOCALE_ID_PROVIDER,
        CategoryService,
        {
            provide: RouteReuseStrategy,
            useClass: CustomRouteReuseStrategy,
        },
        { provide: UrlSerializer, useClass: LowercaseRouteUrlSerializer },
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
    ],
})
export class AppModule {
    private platformId = inject<Object>(PLATFORM_ID);

    public platformServices: any;

    constructor() {
        AppGlobalsModule.isServer = isPlatformServer(this.platformId);
    }
}
